import type { SingleUser, UserManagementData } from "@/types";
import { asyncCall } from "./call";
import { UserRightsMetaData, UserRightsMetaDataResponse } from "./types";

export class UserManagementConnector {
  urlPrefix: string;
  sessionID: string;
  constructor(urlPrefix: string, sessionID: string) {
    this.urlPrefix = urlPrefix;
    this.sessionID = sessionID;
  }

  /**
   *
   * @returns
   */
  async getAllUsers() {
    const result: UserManagementData[] = await asyncCall(this.urlPrefix + "/api/get-users-in-contract", {
      session: this.sessionID,
    });
    return result;
  }

  /**
   *
   * @param id
   * @returns
   */
  async getUserDetail(id: string) {
    const result: SingleUser = await asyncCall(this.urlPrefix + "/api/get-user-details", {
      session: this.sessionID,
      selectedUserId: id,
    });
    return result;
  }

  /**
   *
   * @returns
   */
  async getRoles() {
    const result: string[] = await asyncCall(this.urlPrefix + "/api/get-assignable-user-roles", {
      session: this.sessionID,
    });

    return result;
  }
  /**
   *
   * @returns
   */
  // const result: string[] = await asyncCall(
  async getRightsMetaInfo(): Promise<UserRightsMetaData | undefined> {
    try {
      const response = (await asyncCall(this.urlPrefix + "/api/get-user-rights-metadata", {
        session: this.sessionID,
      })) as UserRightsMetaDataResponse;
      if (!response) return;

      const output = {
        meta: new Map(Object.entries(response.userRightMetadata)),
        roles: response.assignableUserRoles,
        userRights: response.userRoleDetails,
      };

      return output as UserRightsMetaData;
    } catch (error) {
      console.error("error", error);
    }
  }

  async updateRoles(
    users: {
      userid: number;
      role: string;
    }[]
  ) {
    try {
      const response = await asyncCall(
        this.urlPrefix + "/api/set-user-role",
        {
          session: this.sessionID,
          users,
        },
        users
      );
      return response;
    } catch (error) {
      console.error("error", error);
    }
  }

  async updateRolesOrThrow(
    users: {
      userid: number;
      role: string;
    }[]
  ) {
    const response = await asyncCall(
      this.urlPrefix + "/api/set-user-role",
      {
        session: this.sessionID,
        users,
      },
      users
    );
    return response;
  }
}
